import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { PriceListResponse } from '../models/price-list.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface PriceListDrawerOptions {
  priceListId?: number;
}

@Injectable({ providedIn: 'root' })
export class PriceListDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: PriceListDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly priceListSaved$$ = new Subject<PriceListResponse>();

  readonly state = this.state$.asObservable();
  readonly priceListSaved$ = this.priceListSaved$$.asObservable();

  open(options: PriceListDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(priceList: PriceListResponse): void {
    this.priceListSaved$$.next(priceList);
  }
}
